var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { compile } from 'expression-eval';
import { Effect } from '../effector/IEffector';
import { AbstractMatcher } from './IMatcher';
/**
 * m = r.obj == p.obj
 */
var DefaultMatcher = /** @class */ (function (_super) {
    __extends(DefaultMatcher, _super);
    function DefaultMatcher() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(DefaultMatcher.prototype, "matcher", {
        get: function () {
            return this._matcher;
        },
        enumerable: true,
        configurable: true
    });
    DefaultMatcher.prototype.match = function (r) {
        var matcher = compile(this.matcher.replace(/^m ?= ?/, ''));
        var policyEffects = this.pm.policies.map(function (p) { return matcher({ p: p, r: r }) ? Effect.Allow : Effect.Deny; });
        return {
            policyEffects: policyEffects,
            result: [],
        };
    };
    return DefaultMatcher;
}(AbstractMatcher));
export { DefaultMatcher };
